import loadable from '@loadable/component';
import { WithLazyHydration } from '../WithLazyHydration';

const ArticleImageLoadable = loadable(() => import('./ArticleImage'), {
  resolveComponent: components => components.ArticleImage
});

export const ArticleImage = WithLazyHydration(ArticleImageLoadable, {
  name: 'ArticleImage'
});
